import React from "react";
import {
  Card,
  Table,
  Form,
  Row,
  Col,
  Dropdown,
} from "react-bootstrap";

import {
  FiEdit2,
  FiTrash2,
} from "react-icons/fi";

export default function PayrollTable({
  activeTab,
  data,
  onEdit,
  onDelete,
}) {

  return (
    <Card className="table-card border-0">

      <Card.Header className="table-header">

        <h6 className="table-title">
          {activeTab === "addition" && "Additions List"}
          {activeTab === "overtime" && "Overtime List"}
          {activeTab === "deduction" && "Deductions List"}
        </h6>

        <Dropdown>
          <Dropdown.Toggle className="sort-btn">
            Sort By : Last 7 Days
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            <Dropdown.Item>Recently Added</Dropdown.Item>
            <Dropdown.Item>Ascending</Dropdown.Item>
            <Dropdown.Item>Descending</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

      </Card.Header>

      <Card.Body className="p-0">

        <div className="filter-bar">

          <div className="entries-wrapper">
            <span>Row Per Page</span>

            <Form.Select className="entries-select">
              <option>10</option>
              <option>20</option>
              <option>30</option>
            </Form.Select>

            <span>Entries</span>
          </div>

          <Form.Control
            placeholder="Search"
            className="search-input"
          />

        </div>

        <div className="table-responsive">

          <Table className="custom-table align-middle mb-0">

            <thead>
              <tr>
                <th>
                  <Form.Check />
                </th>

                <th>Name</th>

                {activeTab === "addition" && (
                  <>
                    <th>Category</th>
                    <th>Default / Unit Amount</th>
                  </>
                )}

                {activeTab === "overtime" && (
                  <th>Rate</th>
                )}

                {activeTab === "deduction" && (
                  <th>Default / Unit Amount</th>
                )}

                <th></th>
              </tr>
            </thead>

            <tbody>

              {data.map((item) => (

                <tr key={item.id}>

                  <td>
                    <Form.Check />
                  </td>

                  <td className="fw-semibold">
                    {item.name}
                  </td>

                  {activeTab === "addition" && (
                    <>
                      <td>{item.category}</td>
                      <td>{item.amount}</td>
                    </>
                  )}

                  {activeTab === "overtime" && (
                    <td>{item.rate}</td>
                  )}

                  {activeTab === "deduction" && (
                    <td>{item.amount}</td>
                  )}

                  <td>

                    <div className="action-icons">

                      <FiEdit2
                        className="action-icon"
                        onClick={() => onEdit(item)}
                      />

                      <FiTrash2
                        className="action-icon"
                        onClick={() => onDelete(item)}
                      />

                    </div>

                  </td>

                </tr>

              ))}

            </tbody>

          </Table>

        </div>

        <Row className="pagination-wrapper">
          <Col>
            Showing 1 - {data.length} of {data.length} entries
          </Col>

          <Col className="text-end">
            <div className="page-number">
              1
            </div>
          </Col>
        </Row>

      </Card.Body>

    </Card>
  );
}